/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreatePageVariableFromAiResponseRequestDto } from '../models/create-page-variable-from-ai-response-request-dto';
import { NewPageVariable } from '../models/new-page-variable';
import { OpenAiPageVariableRequestDto } from '../models/open-ai-page-variable-request-dto';
import { PageVariable } from '../models/page-variable';
import { PageVariableWithRelations } from '../models/page-variable-with-relations';
import { PartialPageVariable } from '../models/partial-page-variable';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class PageVariableControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation pageVariableControllerCount
   */
  static readonly PageVariableControllerCountPath = '/page-variables/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation pageVariableControllerGenerateByAi
   */
  static readonly PageVariableControllerGenerateByAiPath = '/page-variables/generate-by-ai';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateByAI()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateByAI$Response(params?: {
    body?: OpenAiPageVariableRequestDto
  }): Observable<StrictHttpResponse<CreatePageVariableFromAiResponseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerGenerateByAiPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreatePageVariableFromAiResponseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateByAI$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateByAI(params?: {
    body?: OpenAiPageVariableRequestDto
  }): Observable<CreatePageVariableFromAiResponseRequestDto> {

    return this.generateByAI$Response(params).pipe(
      map((r: StrictHttpResponse<CreatePageVariableFromAiResponseRequestDto>) => r.body as CreatePageVariableFromAiResponseRequestDto)
    );
  }

  /**
   * Path part for operation pageVariableControllerGenerateFromAiResponse
   */
  static readonly PageVariableControllerGenerateFromAiResponsePath = '/page-variables/generate-from-ai-response';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateFromAIResponse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateFromAIResponse$Response(params?: {
    body?: CreatePageVariableFromAiResponseRequestDto
  }): Observable<StrictHttpResponse<PageVariableWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerGenerateFromAiResponsePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PageVariableWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateFromAIResponse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateFromAIResponse(params?: {
    body?: CreatePageVariableFromAiResponseRequestDto
  }): Observable<PageVariableWithRelations> {

    return this.generateFromAIResponse$Response(params).pipe(
      map((r: StrictHttpResponse<PageVariableWithRelations>) => r.body as PageVariableWithRelations)
    );
  }

  /**
   * Path part for operation pageVariableControllerFindById
   */
  static readonly PageVariableControllerFindByIdPath = '/page-variables/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<PageVariableWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PageVariableWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<PageVariableWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<PageVariableWithRelations>) => r.body as PageVariableWithRelations)
    );
  }

  /**
   * Path part for operation pageVariableControllerDeleteById
   */
  static readonly PageVariableControllerDeleteByIdPath = '/page-variables/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation pageVariableControllerUpdateById
   */
  static readonly PageVariableControllerUpdateByIdPath = '/page-variables/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: PartialPageVariable
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: PartialPageVariable
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation pageVariableControllerFind
   */
  static readonly PageVariableControllerFindPath = '/page-variables';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<PageVariableWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PageVariableWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<PageVariableWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PageVariableWithRelations>>) => r.body as Array<PageVariableWithRelations>)
    );
  }

  /**
   * Path part for operation pageVariableControllerCreate
   */
  static readonly PageVariableControllerCreatePath = '/page-variables';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewPageVariable
  }): Observable<StrictHttpResponse<PageVariable>> {

    const rb = new RequestBuilder(this.rootUrl, PageVariableControllerService.PageVariableControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PageVariable>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewPageVariable
  }): Observable<PageVariable> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<PageVariable>) => r.body as PageVariable)
    );
  }

}
